import { BreakUpItemProps } from '@/src/types/FareBreakup'
// import SuperCoinsIcon from '@assests/svgs/SupercoinIcon'

import { isEmpty } from '@/src/utils/generalUtils/isEmpty'
import { Box, Typography } from '@mui/material'
import React, { useState } from 'react'

const BreakupItem: React.FC<BreakUpItemProps> = props => {
    const {
        cfw,
        perPaxPricing,
        isDiscount,
        cashCollectionFeeAmount,
        travellerCallout,
        isTotalItem,
        isSuperCoin,
        strikeOffDetails,
        price = 0,
        title,
        formatCurrency
    } = props
    const { displayAmount, strikeOffAmount } = strikeOffDetails || {}
    const newPrice = price < 0 ? -1 * price : price
    const [showDropdown, setShowDropdown] = useState(false)
    const handleToggleDropdown = () => {
        setShowDropdown(!showDropdown)
    }

    const getPassengerType = (paxType: string, paxCount: number) => {
        switch (paxType) {
            case 'ADT':
                return paxCount > 1 ? 'Adult(s)' : 'Adult'
            case 'CHD':
                return paxCount > 1 ? 'Children' : 'Child'
            case 'INF':
                return paxCount > 1 ? 'Infant(s)' : 'Infant'
            default:
                return ''
        }
    }
    return (
        <Box>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    mb: isTotalItem ? 0 : 0.75
                }}
            >
                <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.825rem' }}>
                    {title}
                </Typography>
                <Typography
                    variant="body2"
                    fontWeight={700}
                    color={isDiscount ? 'success.main' : 'text.primary'}
                    sx={{ fontSize: '0.825rem' }}
                >
                    {isDiscount && newPrice !== 0 ? formatCurrency(Math.abs(newPrice) * -1) : formatCurrency(newPrice)}
                </Typography>
            </Box>
            {/* Only show per-pax breakdown for Base Fare and only when dropdown is open */}
            {title === 'Base Fare' && showDropdown && Array.isArray(perPaxPricing) && perPaxPricing.length > 0 && (
                <Box sx={{ pl: 2 }}>
                    {perPaxPricing.map((item: any, idx: number) => {
                        const passengerType = getPassengerType(item?.paxType, item?.paxCount)
                        return (
                            <Box
                                key={idx}
                                sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 0.5 }}
                            >
                                <Typography variant="caption" color="text.secondary">
                                    {passengerType} ({item?.paxCount} x {formatCurrency(item?.paxAmount)})
                                </Typography>
                                <Typography variant="caption" color="text.secondary">
                                    {formatCurrency(item?.paxAmount * item?.paxCount)}
                                </Typography>
                            </Box>
                        )
                    })}
                </Box>
            )}
            {isSuperCoin && isDiscount ? <Box sx={{ ml: 2 }}>{/* <SuperCoinsIcon /> */}</Box> : ''}
            {/* </Box> */}
            {title?.toLowerCase() === 'conveinience fee' && !isEmpty(cashCollectionFeeAmount) && (
                <Typography
                    variant="body2"
                    color="text.secondary"
                >{`${formatCurrency(cashCollectionFeeAmount || 0)} cash collection charge included`}</Typography>
            )}
            {!isEmpty(strikeOffAmount) && !isEmpty(displayAmount) ? (
                <>
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 3 }}>
                        <Typography variant="body2" sx={{ textDecoration: 'line-through', color: '#808080' }}>
                            {formatCurrency(strikeOffAmount || 0)}
                        </Typography>
                        <Typography variant="body2" sx={{ color: displayAmount ? '#1A1A1A' : '#11A670' }}>
                            {displayAmount ? formatCurrency(displayAmount) : 'Free'}
                        </Typography>
                    </Box>
                </>
            ) : (
                ''
            )}
        </Box>
    )
}

export default BreakupItem
